/* eslint-disable react-hooks/exhaustive-deps */
import { debounce } from "lodash";
import React, { useState, useEffect, useRef } from "react";
import { SxProps, TextField, styled, Theme } from "@mui/material";
// import images from "../../assets/images";

import "./search-bar.scss";
import { Search, SearchStatus } from "../icons";

const StyledSearch = styled(TextField)(({ theme: { palette } }) => ({
  "&.MuiTextField-root": {
    backgroundColor: palette.theme?.secondary[200],
    borderRadius: "0.5rem",
    padding: "0.375rem 0.75rem",
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "0.875rem",
    padding: "0rem",
    paddingLeft: "1.375rem",
  },
  ".MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

interface ISearchBar {
  placeholder?: string;
  handleSearch: (key: string) => void;
  debounceTime?: number;
  className?: string;
  InputProps?: any;
  sx?: SxProps<Theme>;
  isDrivePage?: boolean;
  searchText?:string
}

const SearchBar = ({
  handleSearch,
  debounceTime = 300,
  className,
  InputProps,
  isDrivePage,
  searchText,
  value = '',
  ...rest
}: ISearchBar) => {
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearchRef = useRef<(value: string) => void>();

  // Set `searchTerm` from localStorage on mount and clear `localStorage` if needed
  useEffect(() => {
    const initialSearchTerm = isDrivePage ? localStorage.getItem("searchTerm") || "" : "";
    setSearchTerm(initialSearchTerm);

    // Set `localStorage` to an empty string on the first render
    if (isDrivePage) {
      localStorage.setItem("searchTerm", "");
    }
  }, [isDrivePage]);

  useEffect(() => {
    setSearchTerm((typeof searchText=='string' && searchText) || '')
  }, [searchText])

  // Initialize the debounced function only once
  useEffect(() => {
    debouncedSearchRef.current = debounce((value: string) => handleSearch(value), debounceTime);
    
    // Cleanup function to cancel debounced call on component unmount
    return () => {
      debouncedSearchRef.current?.cancel();
    };
  }, [handleSearch, debounceTime]);

  useEffect(() => {
    setSearchTerm(value || '')
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (isDrivePage) {
      localStorage.setItem("searchTerm", value);
    }

    // Call the debounced search function
    if (debouncedSearchRef.current) {
      debouncedSearchRef.current(value);
    }
  };

  const handleKeyDown = (event: any) => {
    event.stopPropagation();
  };

  const handleClick = (event: any) => {
    event.stopPropagation();
  };

  return (
    <div className={`${className} search-wrapper`}>
      <StyledSearch
        fullWidth
        className="s3"
        value={searchTerm}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onClick={handleClick}
        autoComplete="off"
        InputProps={InputProps}
        {...rest}
      />
      <span className="search-icon">
        {
          searchTerm ?
          <SearchStatus fontSize="small" sx={{ color: searchTerm ? "grey.900": "grey.700" }}/> : 
          <Search fontSize="small" sx={{ color: searchTerm ? "grey.900": "grey.700" }}/>
        }
      </span>
      {/* <img src={images.search} alt="search icon" /> */}
    </div>
  );
};

export { SearchBar };
export default SearchBar;
